module.exports = __webpack_public_path__ + "static/img/title1IN.30cbfe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/title1IN.svg
// module id = 2vFL
// module chunks = 0